import { IDropdownSelector } from "@Modules/common/Form/FormInputs/DropdownSelector/IDropdownSelector";
import { FORM_ENUM } from "@Modules/modals/components/UserDetails/FormData";
import React from "react";
import { IDetailsForm } from "../../IRenewBookingForm";

const useDetailsForm = ({
    setFormDetails,
    isGstChecked,
    billingStateNonMandatory,
}: IDetailsForm.IProps) => {
    // Update the value and error on input change
    const handleFormChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
    ) => {
        setFormDetails({
            key: e?.target?.name,
            value: e?.target?.value,
            error:
                FORM_ENUM?.[e.target.name]?.validate?.(e?.target?.value, {
                    billingStateNonMandatory,
                    isGstChecked,
                }) ?? null,
        });
    };

    const handleDropdownSelectChange = (
        option: IDropdownSelector.Option | null
    ) => {
        setFormDetails({
            key: option?.name,
            value: option?.value,
            error:
                FORM_ENUM?.[option?.name]?.validate?.(option?.value || "", {
                    billingStateNonMandatory,
                    isGstChecked,
                }) ?? null,
            showError: true,
        });
    };

    // This function has two tasks:
    // 1) Show the error on input blur
    // 2) Post analytics data for the event
    const handleFieldBlur = (
        e: React.FocusEvent<HTMLInputElement | HTMLSelectElement>
    ) => {
        setFormDetails({
            key: e?.target?.name,
            showError: true,
            error:
                FORM_ENUM?.[e.target.name]?.validate?.(e?.target?.value, {
                    billingStateNonMandatory,
                    isGstChecked,
                }) ?? null,
        });
    };

    return { handleFormChange, handleDropdownSelectChange, handleFieldBlur };
};

export default useDetailsForm;
